import './App.css';
import React, { useEffect,useState } from 'react';
import {  Route, Routes, useLocation,useNavigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AccountPage from './pages/Account';
import Header from './components/Header';
import AccountInfo from './components/AccountInfo';

import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';

import ScrollToTop from './components/ScrollToTop';

import Footer from './components/Footer';
import PhoneAuth from './pages/phoneAuth';
import CheckoutPage from './pages/CheckOut';
import SubscriptionCheckout from './pages/SubscriptionCheckoutPage';
import SearchPage from './pages/SearchPage';

import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyAndPolicy from './pages/PrivacyPolicy';

import ShippingPolicy from './pages/ShippingPolicy';
import RoomListPage from './pages/RoomListPage';
import RoomDetailsPage from './pages/RoomDetailsPage';
import RoomCheckoutPage from './pages/CheckOut';
import CancellationPolicy from './pages/CancellationPolicy';
import PackageListPage from './pages/tourPackageList';
import PackageDetailsPage from './pages/packageDetails';
import PackageCheckoutPage from './pages/PackageCheckOut';
import ProfileReminder from './components/ProfileReminder';
import SiteSeeingListPage from './pages/SiteSeeingList';
import CabAndRental from './pages/CabAndRental';
import SightseeingDetailsPage from './pages/SightseeingDetailsPage';
import CabRentalListPage from './pages/cabRental';
import CabRentalDetailsPage from './pages/CabRentalDetails';
import WhatsAppChatButton from './components/WhatAppChatBtn';
import { Toaster } from "react-hot-toast";


function App() {
  const isMobile = window.innerWidth < 768;
  const location = useLocation();
  const noHeaderRoutes = ["/login","/not-serviceable"];
  const noFooterRoutes = ["/rooms","/login","/search","/not-serviceable","/tour-packages"];

 
  if (process.env.NODE_ENV !== 'development') {
    console.log = function () {};
    console.warn = function () {};
    console.error = function () {};
  }
  
  
  return (
    <>
     <Toaster 
        position="top-center" 
        reverseOrder={false}
        toastOptions={{
          duration: 4000,
          style: {
            marginTop: '80px',
          },
        }}
      />
      <div className="app">
       
        {/* Conditionally render Header */}
        {!noHeaderRoutes.includes(location.pathname) && <Header />}
        <ScrollToTop/>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/account/details" element={<AccountInfo />} />
          <Route path="/contact" element={<ContactPage/>}/>
          <Route path="/about" element={<AboutPage/>}/>
          <Route path="/Rooms" element={<RoomListPage/>}/>
          <Route path="/rooms/:id" element={<RoomDetailsPage />} />
          <Route path="/login" element={<PhoneAuth/>}/>
          <Route path="/checkout/:id" element={<RoomCheckoutPage />} />
          <Route path="/sub-checkout" element={<SubscriptionCheckout/>}/>
          <Route path="/search" element={<SearchPage/>}/>
          <Route path="/termsandcondition" element={<TermsAndConditions/>}/>
          <Route path="/privacy-policy" element={<PrivacyAndPolicy/>}/>
          <Route path="/cancellation-policy" element={<CancellationPolicy/>}/>
          <Route path="/shipping-policy" element={<ShippingPolicy/>}/>
          <Route path="/tour-packages" element={<PackageListPage/>}/>
           <Route path="/cab-and-rental" element={<CabAndRental/>}/>
          <Route path="/site-seeing-details/:id" element={<SightseeingDetailsPage />} />
         <Route path="/cab-rental-details/:id" element={<CabRentalDetailsPage />} />
          <Route path="/packages/:id" element={<PackageDetailsPage />} />
          <Route path="/package-checkout/:id" element={<PackageCheckoutPage />} /> 




          
        </Routes>
       
        {!noFooterRoutes.includes(location.pathname) && <Footer />}
        <ProfileReminder />
        <WhatsAppChatButton />
      </div>
     </> 
  );
}

export default App;
